import { decodeBase64, encodeBase64 } from "./base64";

/**
 * Search Analytics の QueryGroup ID から Project ID を復元する。
 * ID 形式: QueryGroup:customers/{org}/projects/{project}/search_analytics/{sa}/query_groups/{group}
 * @param queryGroupId Base64 エンコード済みの QueryGroup ID
 * @returns Base64 エンコード済み Project ID（失敗時は null）
 */
export function toProjectIdFromSaQueryGroupId(
  queryGroupId: string,
): string | null {
  try {
    const decoded = decodeBase64(queryGroupId);
    const parts = decoded.split("/");
    const orgDb = parts[1];
    const projectDb = parts[3];
    if (!orgDb || !projectDb) return null;
    const rawProject = `Project:customers/${orgDb}/projects/${projectDb}`;
    return encodeBase64(rawProject);
  } catch {
    return null;
  }
}

/**
 * Search Analytics の QueryGroup ID から SearchAnalytics ID を復元する。
 * @param queryGroupId Base64 エンコード済みの QueryGroup ID
 * @returns Base64 エンコード済み SearchAnalytics ID（失敗時は null）
 */
export function toSearchAnalyticsIdFromSaQueryGroupId(
  queryGroupId: string,
): string | null {
  try {
    const decoded = decodeBase64(queryGroupId);
    const parts = decoded.split("/");
    const orgDb = parts[1];
    const projectDb = parts[3];
    const saDb = parts[5];
    if (!orgDb || !projectDb || !saDb) return null;
    const rawSa = `SearchAnalytics:customers/${orgDb}/projects/${projectDb}/search_analytics/${saDb}`;
    return encodeBase64(rawSa);
  } catch {
    return null;
  }
}
